"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 27 19",
    width: props.size || props.width || "24px",
    id: "done",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 10.772L8.458 18 26 1",
    fillRule: "nonzero",
    stroke: props.color,
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "square"
  }));
};
var _default = exports["default"] = SvgComponent;